/* tslint:disable */
/* eslint-disable */
/**
 * IGA Gewinnspiel API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: info@wapp.gmbh
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CustomWinnerFieldValue
 */
export interface CustomWinnerFieldValue {
    /**
     * 
     * @type {string}
     * @memberof CustomWinnerFieldValue
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CustomWinnerFieldValue
     */
    value: string;
}

export function CustomWinnerFieldValueFromJSON(json: any): CustomWinnerFieldValue {
    return CustomWinnerFieldValueFromJSONTyped(json, false);
}

export function CustomWinnerFieldValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomWinnerFieldValue {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'value': json['value'],
    };
}

export function CustomWinnerFieldValueToJSON(value?: CustomWinnerFieldValue | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'value': value.value,
    };
}


